import axios from "axios";

export const state = {
    procedurepatients: [],
};

export const getters = {
    procedurepatients: state => state.procedurepatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.procedurepatients = newValue
    },
};

export const actions = {
    fetchProcedurePatients({ commit }) {
        axios.get('/procedurepatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterProcedurePatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterprocedurepatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
